<template>
    <p class="tw-text-sm tw-text-gray-500">
        <slot />
    </p>
</template>